import { render, staticRenderFns } from "./FormatPhoneNumber.vue?vue&type=template&id=33420feb"
import script from "./FormatPhoneNumber.vue?vue&type=script&lang=js"
export * from "./FormatPhoneNumber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports